/* eslint-disable no-console */
/* eslint-disable @typescript-eslint/ban-types */
/* eslint-disable @typescript-eslint/no-explicit-any */
/* eslint-disable @typescript-eslint/explicit-module-boundary-types */
import { isValue } from '../../helpers';
import { DefaultEnvs } from '../../types';
import { obfuscateJson } from '../../util/';
import { Logger } from '../logger';

export const sendErrorApi = (config: {
  environment: DefaultEnvs;
  endpoint: string;
  status: number;
  method: string;
  request: string;
  response: string;
  bugsnagClient?: any;
  name?: string;
}): void => {
  const optionObfuscate = {
    listWordsObfuscate: ['password', 'pass', 'cpf', 'rg', 'name', 'lastname'],
  };

  let requestObfuscate = {};
  try {
    requestObfuscate = obfuscateJson(config.request, optionObfuscate);
  } catch (error) {
    console.error(error);
  }

  let responseObfuscate = {};
  try {
    responseObfuscate = obfuscateJson(config.response, optionObfuscate);
  } catch (error) {
    console.error(error);
  }
  const bugService = {
    Name: config.name ? config.name : '',
    Environment: config.environment,
    Method: config.method,
    Status: config.status,
    Endpoint: config.endpoint,
    Request: requestObfuscate,
    Response: responseObfuscate,
  };
  try {
    if (isValue(config.bugsnagClient)) {
      config.bugsnagClient.notify(
        new Error(`Erro de Serviço : [${bugService.Name}]`),
        (report: any) => {
          report.addMetadata('Service', bugService);
          report.severity = 'info';
        },
      );
    }
  } catch (error: any) {
    Logger.info('Erro ao dispirar error ao Bugsnag', error);
  }
};
